import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

const TrackTime = () => {
  let sessionId = localStorage.getItem("sessionId");

  if (!sessionId) {
    sessionId = uuidv4(); // Nếu chưa có, tạo mới
    localStorage.setItem("sessionId", sessionId);
  }

  let startTime = new Date().toISOString(); // Thời gian bắt đầu

  const sendSessionData = async () => {
    const endTime = new Date().toISOString();
    const duration = (new Date(endTime) - new Date(startTime)) / 1000; // Thời gian dùng

    if (duration > 2) {
      try {
        await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/session/getTime`,
          {
            sessionId,
            startTime,
            endTime,
            duration,
          }
        );
      } catch (error) {
        console.error("Lỗi khi gửi dữ liệu session:", error);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", sendSessionData);
    return () => {
      sendSessionData();
      window.removeEventListener("beforeunload", sendSessionData);
    };
  }, []);

  return null;
};

export default TrackTime;
